/**
 * Computes the solid hex color that results from blending
 * alpha(primaryColor, 0.08) on top of white (#fff).
 * Used to keep the AppBar, BottomNav, and Android theme-color
 * meta tag perfectly in sync.
 *
 * @param {string} primaryHex - hex color e.g. "#7c3aed"
 * @returns {string} solid hex color string e.g. "#f5effe"
 */
export function getPrimaryBlendedColor(primaryHex) {
  const hex = primaryHex.replace("#", "");
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  const a = 0.08;
  const toHex = (v) => Math.round(v * a + 255 * (1 - a)).toString(16).padStart(2, "0");
  return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
}
